// Create Delivery Use Case

import {DistributionRepository} from '../repository/DistributionRepository';
import {DistributionRecord, CreateDeliveryForm} from '../models/distribution.model';

export class CreateDeliveryUseCase {
  constructor (private distributionRepository: DistributionRepository) {}

  async execute (deliveryData: CreateDeliveryForm): Promise<{ record: DistributionRecord; message?: string }> {
    try {

      // Business Logic Validation
      if (!deliveryData.marketerId || !deliveryData.productId) {
        throw new Error('Marketer ID and Product ID are required');
      }

      // Validate deliveredBy field is provided
      if (!deliveryData.deliveredBy) {
        throw new Error('Delivered By field is required. Please ensure you are authenticated.');
      }

      // For non-serial products, quantity is required
      if (!deliveryData.serials || deliveryData.serials.length === 0) {
        if (!deliveryData.quantity || deliveryData.quantity <= 0) {
          throw new Error('Quantity must be greater than 0 for non-serial products');
        }
      }

      // For serial products, serials array is required
      if (deliveryData.serials && deliveryData.serials.length > 0) {
        if (deliveryData.serials.length === 0) {
          throw new Error('At least one serial must be selected for serial products');
        }
      }

      const result = await this.distributionRepository.createDelivery(deliveryData);

      return result;
    } catch (error) {
      throw error;
    }
  }
}


